// Momentum SMS on/off lives in DataFabric next to Momentum Voice, keyed by the
// Toolbox user. DataFabric reads the AMS agency/user from the Toolbox token and
// stores the MyAMP company/user sent here, so the AMS text messages this user is
// notified about become Command Center tasks for this IA.AI user.
import {
  getMyAmpCompanyId,
  getMyAmpUserId,
  getToolboxHeaders,
  handleResponse,
} from './momentumVoiceService';

export interface MomentumSmsStatus {
  isEnabled: boolean;
}

export async function getMomentumSmsStatus(): Promise<MomentumSmsStatus> {
  const response = await fetch(
    `${process.env.REACT_APP_DataFabric_Url}/api/MomentumSms/get/integration-state`,
    {
      method: 'GET',
      headers: getToolboxHeaders(),
    },
  );
  const data = await handleResponse<{
    IsEnabled?: boolean;
    isEnabled?: boolean;
  }>(response);
  return { isEnabled: data.IsEnabled ?? data.isEnabled ?? false };
}

export async function setMomentumSmsState(enabled: boolean): Promise<void> {
  const response = await fetch(
    `${process.env.REACT_APP_DataFabric_Url}/api/MomentumSms/save/integration-state`,
    {
      method: 'POST',
      headers: getToolboxHeaders(),
      body: JSON.stringify({
        IsEnabled: enabled,
        IntegrationId: getMyAmpCompanyId(),
        IntegrationUserId: getMyAmpUserId(),
      }),
    },
  );
  await handleResponse<unknown>(response);
}
